// 'use strict'
// const sortingMixins = {
//     data() {
//         return {
//             dragStartDisabled: true,
//         }
//     },
//     methods: {
//         handleDragStart(e) {
//             e.dataTransfer.setData('text/plain', e.currentTarget.dataset.index)
//         },
//         handleDragEnter(e) {
//             e.currentTarget.classList.add('hover')
//         },
//         handleDragLeave(e) {
//             e.currentTarget.classList.remove('hover')
//         },
//         handleDragOver(e) {
//             e.preventDefault()
//         },
//         handleDrop(e) {
//             e.preventDefault()
//             const itemIndex = e.dataTransfer.getData('text/plain'),
//                 droppedIndex = e.currentTarget.dataset.index
//             Array.from(e.currentTarget.parentNode.children).map(tr => {
//                 tr.classList.remove('hover')
//             })
//             this.handleListChange(itemIndex, droppedIndex)
//         },
//         handleListChange(index, newIndex) {
//             if (!this.positions?.length) return
//             let oldIndex = parseInt(index, 10),
//                 newPositionIndex = parseInt(newIndex, 10),
//                 movedItem = this.positions[oldIndex]
//             this.positions.splice(oldIndex, 1)
//             this.positions.splice(newPositionIndex, 0, movedItem)
//             this.setNewSorting()
//         },
//     }
// }
//
// export default sortingMixins


'use strict'

const sortingMixins = {
    data() {
        return {
            draggedSortableIndex: null,
            dragOverSortableIndex: null,
            dragOverPlacement: null,
        }
    },

    methods: {
        getSortableRows() {
            return this.positions || []
        },

        isSortableRowVisible(row) {
            return !!(row && (row.status || row.showDeleted || this.showDeleted))
        },

        isSortableRowsDisabled() {
            return !!(
                this.editingIsDisabled ||
                this.positionsEditingIsDisabled ||
                this.closedFinancialPeriodDataEditingDisabled ||
                this.modalDataIsLoading ||
                this.dataIsSending
            )
        },

        canSortRows() {
            return !this.isSortableRowsDisabled() &&
                this.getSortableVisibleIndexes().length > 1
        },

        getSortableVisibleIndexes() {
            const rows = this.getSortableRows()

            if (!Array.isArray(rows)) return []

            return rows
                .map((row, index) => ({ row, index }))
                .filter(item => this.isSortableRowVisible(item.row))
                .map(item => item.index)
        },

        clearSortableDragState() {
            this.draggedSortableIndex = null
            this.dragOverSortableIndex = null
            this.dragOverPlacement = null
        },

        getSortableRowDragClass(index) {
            return {
                'sortable-row--dragging': this.draggedSortableIndex === index,
                'sortable-row--drag-before': this.dragOverSortableIndex === index && this.dragOverPlacement === 'before',
                'sortable-row--drag-after': this.dragOverSortableIndex === index && this.dragOverPlacement === 'after',
            }
        },

        getSortableDropPlacement(event, index = null) {
            const row = event.currentTarget
            const rect = row.getBoundingClientRect()
            const middle = rect.top + rect.height / 2
            const deadZone = 6

            if (
                index !== null &&
                this.dragOverSortableIndex === index &&
                this.dragOverPlacement &&
                Math.abs(event.clientY - middle) <= deadZone
            ) {
                return this.dragOverPlacement
            }

            return event.clientY < middle ? 'before' : 'after'
        },

        getNextSortableVisibleIndex(index) {
            const visibleIndexes = this.getSortableVisibleIndexes()
            const visibleIndex = visibleIndexes.indexOf(index)

            if (visibleIndex === -1) return null

            return visibleIndexes[visibleIndex + 1] ?? null
        },

        getCanonicalSortableDropTarget(index, placement) {
            if (placement === 'after') {
                const nextIndex = this.getNextSortableVisibleIndex(index)

                if (nextIndex !== null) {
                    return {
                        index: nextIndex,
                        placement: 'before',
                    }
                }
            }

            return {
                index,
                placement,
            }
        },

        setSortableDragOver(event, index) {
            const rawPlacement = this.getSortableDropPlacement(event, index)
            const target = this.getCanonicalSortableDropTarget(index, rawPlacement)

            this.dragOverSortableIndex = target.index
            this.dragOverPlacement = target.placement
        },

        handleSortableDragStart(event, index) {
            if (!this.canSortRows()) {
                event.preventDefault()
                return
            }

            this.draggedSortableIndex = index
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('text/plain', String(index))
        },

        handleSortableDragEnter(event, index) {
            const rows = this.getSortableRows()

            if (this.draggedSortableIndex === null || this.draggedSortableIndex === index) return
            if (!this.isSortableRowVisible(rows[index])) return

            this.setSortableDragOver(event, index)
        },


        handleSortableDragOver(event, index) {
            const rows = this.getSortableRows()

            if (this.draggedSortableIndex === null || this.draggedSortableIndex === index) return
            if (!this.isSortableRowVisible(rows[index])) return

            event.dataTransfer.dropEffect = 'move'
            this.setSortableDragOver(event, index)
        },

        // handleSortableDragLeave(event) {
        //     const tbody = event.currentTarget.closest('tbody')
        //
        //     if (
        //         tbody &&
        //         event.relatedTarget &&
        //         tbody.contains(event.relatedTarget)
        //     ) {
        //         return
        //     }
        //
        //     this.dragOverSortableIndex = null
        //     this.dragOverPlacement = null
        // },

        handleSortableDragLeave() {
            // Не очищаем индикатор здесь, чтобы синяя линия не мигала/не прыгала
            // при переходе мышки между соседними строками.
            // Очистка происходит в handleSortableDrop и handleSortableDragEnd.
        },

        handleSortableDrop(event, targetIndex) {
            if (this.draggedSortableIndex === null) {
                this.clearSortableDragState()
                return
            }

            const oldIndex = Number(event.dataTransfer.getData('text/plain'))

            const rawPlacement = this.getSortableDropPlacement(event, targetIndex)
            const target = this.getCanonicalSortableDropTarget(targetIndex, rawPlacement)

            this.moveSortableRowTo(oldIndex, target.index, target.placement)

            this.clearSortableDragState()
        },

        handleSortableDragEnd() {
            this.clearSortableDragState()
        },

        moveSortableRowTo(oldIndex, targetIndex, placement = 'before') {
            const rows = this.getSortableRows()

            if (
                !Array.isArray(rows) ||
                !Number.isInteger(oldIndex) ||
                !Number.isInteger(targetIndex) ||
                oldIndex < 0 ||
                targetIndex < 0 ||
                oldIndex >= rows.length ||
                targetIndex >= rows.length ||
                oldIndex === targetIndex
            ) {
                return
            }

            let insertIndex = placement === 'after' ? targetIndex + 1 : targetIndex

            if (oldIndex < insertIndex) {
                insertIndex -= 1
            }

            if (oldIndex === insertIndex) {
                return
            }

            const [movedRow] = rows.splice(oldIndex, 1)
            rows.splice(insertIndex, 0, movedRow)

            this.afterSortableRowsChanged()
            this.clearSortableDragState()
        },

        canMoveSortableRowStep(index, direction) {
            if (!this.canSortRows()) return false

            const visibleIndexes = this.getSortableVisibleIndexes()
            const visibleIndex = visibleIndexes.indexOf(index)
            const targetVisibleIndex = visibleIndex + direction

            return visibleIndex !== -1 &&
                targetVisibleIndex >= 0 &&
                targetVisibleIndex < visibleIndexes.length
        },

        moveSortableRowStep(index, direction) {
            if (!this.canMoveSortableRowStep(index, direction)) return

            const visibleIndexes = this.getSortableVisibleIndexes()
            const visibleIndex = visibleIndexes.indexOf(index)
            const targetIndex = visibleIndexes[visibleIndex + direction]

            this.moveSortableRowTo(
                index,
                targetIndex,
                direction > 0 ? 'after' : 'before'
            )
        },

        afterSortableRowsChanged() {
            if (typeof this.setNewSorting === 'function') {
                this.setNewSorting()
                return
            }

            this.normalizeSortableRowsSorting()
        },

        handleSortableBodyDragOver(event) {
            if (this.draggedSortableIndex === null) return

            const visibleIndexes = this.getSortableVisibleIndexes()

            if (!visibleIndexes.length) return

            const rows = Array.from(
                event.currentTarget.querySelectorAll('tr.sortable-row')
            )

            if (!rows.length) return

            const y = event.clientY

            event.dataTransfer.dropEffect = 'move'

            for (let i = 0; i < rows.length; i++) {
                const rect = rows[i].getBoundingClientRect()

                if (y < rect.top) {
                    this.dragOverSortableIndex = visibleIndexes[i]
                    this.dragOverPlacement = 'before'
                    return
                }

                if (y >= rect.top && y <= rect.bottom) {
                    return
                }
            }

            this.dragOverSortableIndex = visibleIndexes[visibleIndexes.length - 1]
            this.dragOverPlacement = 'after'
        },

        handleSortableBodyDrop(event) {
            if (this.draggedSortableIndex === null) {
                this.clearSortableDragState()
                return
            }

            if (
                this.dragOverSortableIndex === null ||
                !this.dragOverPlacement
            ) {
                this.clearSortableDragState()
                return
            }

            const oldIndexFromEvent = Number(event.dataTransfer.getData('text/plain'))
            const oldIndex = Number.isInteger(oldIndexFromEvent)
                ? oldIndexFromEvent
                : this.draggedSortableIndex

            this.moveSortableRowTo(
                oldIndex,
                this.dragOverSortableIndex,
                this.dragOverPlacement
            )

            this.clearSortableDragState()
        },

        normalizeSortableRowsSorting() {
            const rows = this.getSortableRows()

            if (!Array.isArray(rows)) return

            rows.forEach((row, index) => {
                row.sorting = index + 1

                if (typeof this.checkPositionHasBeenUpdated === 'function') {
                    this.checkPositionHasBeenUpdated(row)
                } else if (!row.isNew) {
                    row.isUpdated = true
                }
            })
        },
        showSortableStepButtons() {
            return false
        },

    },
}

export default sortingMixins